import type {Intent, SearchParams} from 'typings/portaro.be.types';
import type {Component} from 'typings/portaro.fe.types';
import type {DefinedAction} from '../../commons/services/defined-action-performer';
import type DefinedActionPerformer from '../../commons/services/defined-action-performer';

export class KpAvailableIntentsComponent implements Component<KpAvailableIntentsComponentBinding> {

    public static readonly componentName = 'kpAvailableIntents';

    controller = KpAvailableIntentsComponentController;
    templateUrl = require('./kp-available-intents.tpl.ftl');
    bindings = {
        availableIntents: '<',
        newSearchWithParamsCallback: '<',
        definedActionReturnedValueHandler: '<'
    } as const;

}

interface KpAvailableIntentsComponentBinding {
    availableIntents: Intent[];
    newSearchWithParamsCallback: (newParams: SearchParams) => void;
    definedActionReturnedValueHandler: (actionReturnedValue: any) => Promise<any>;
}

class KpAvailableIntentsComponentController implements KpAvailableIntentsComponentBinding {
    availableIntents: Intent[];
    newSearchWithParamsCallback: (newParams: SearchParams) => void;
    definedActionReturnedValueHandler: (actionReturnedValue: any) => Promise<any>;

    /*@ngInject*/
    constructor(private definedActionPerformer: DefinedActionPerformer) {
    }

    public intentsNotEmpty(): boolean {
        return this.availableIntents?.length > 0;
    }

    public newSearchWithParams(newParams: SearchParams): void {
        return this.newSearchWithParamsCallback(newParams);
    }

    public async performDefinedAction(action: DefinedAction): Promise<any> {
        const actionReturnedValue: any = await this.definedActionPerformer.performAction(action);
        return this.definedActionReturnedValueHandler(actionReturnedValue);
    }
}